import React from 'react';
import ReactMarkdown from 'react-markdown';

import { Skeleton, Typography } from 'wtb-components';
import { useTransactionContext, useLocaleContext, useAppContext } from 'context';
import styles from './AboutMerchant.module.css';

const AboutMerchant = () => {

  const { isLoading } = useAppContext();
  const { locale } = useLocaleContext();
  const { merchant } = useTransactionContext();

  return isLoading
    ? (
      <div data-testid="about-merchant-loading">
        {[ ...Array(5).keys() ].map((value) => (
          <Skeleton key={`skeleton-${value}`} />
        ))}
        <Skeleton width="65%" />
      </div>
    ) : (
      <Typography
        className={styles.root}
        data-testid="about"
        variant="body2"
        component="span"
      >
        <ReactMarkdown>{merchant.info[locale]}</ReactMarkdown>
      </Typography>
    );
};

export default AboutMerchant;
